import 'polyfills/promiseWithResolvers';
import { pdfjs } from 'react-pdf';

if (typeof window !== 'undefined' && 'Worker' in window) {
  pdfjs.GlobalWorkerOptions.workerPort = new Worker(
    new URL('./pdfCompatWorker.ts', import.meta.url),
    { type: 'module' },
  );
}
